const formatDuration = (seconds: number): string => {
  const totalSeconds = parseInt(`${seconds}`, 10);
  const hours = Math.floor(totalSeconds / 3600);

  let remainingSeconds = totalSeconds % 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  remainingSeconds %= 60;

  const prettyHoursWithSeparator = hours > 0 ? `${hours}h` : '';
  const prettyMinutes = minutes > 0 ? `${minutes}m` : '';

  return `${prettyHoursWithSeparator} ${prettyMinutes} ${remainingSeconds}s`.trim();
};

export default formatDuration;
